var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content ck-content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4999a03b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/investorRelations/content.vue
// module id = null
// module chunks = 